export default __webpack_public_path__ + "static/media/com_logo.a688931c.png";